import script from "./CheckinPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinPage.vue?vue&type=script&setup=true&lang=js"

import "./CheckinPage.vue?vue&type=style&index=0&id=412ddf22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412ddf22"]])

export default __exports__